// extracted by mini-css-extract-plugin
export default {"userDashboard":"UserDashboardPage_userDashboard__xPddJ","migrationBanner":"UserDashboardPage_migrationBanner__kvhTY","fadeInUp":"UserDashboardPage_fadeInUp__cfR9N"};